import { DecimalPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CompilingWidgetService } from '../../../services/compiling/widget.service';
import { RadioButtonCustomization } from './radiobutton-edit';

@Component({
  selector: 'lib-radiobutton-compiling',
  imports: [ReactiveFormsModule, RadioButtonModule, DecimalPipe],
  template: `
    @let widget = widgetService.widget();
    @let formControl = widgetService.formControl();
    @if (widget && formControl) {
      <div class="flex w-full flex-col gap-2">
        <label [for]="groupId" class="whitespace-pre-line text-justify">
          {{ widget.customization.description }} (max
          {{ widgetService.maxPoints() | number: '1.0-1' }}
          pt)
        </label>
        <div
          [class]="'p-fluid flex' + topologyStyle"
          (keydown)="onKeyDown($event)"
        >
          @for (
            option of widget.customization.options;
            track $index;
            let i = $index
          ) {
            <div class="flex flex-row items-center gap-2 whitespace-nowrap">
              @let id = groupId + '_option_' + i;
              <p-radioButton
                [autofocus]="false"
                [inputId]="id"
                [name]="groupId"
                [value]="option.value"
                [formControl]="formControl"
              ></p-radioButton>
              <label [for]="id">
                {{ option.label }}
              </label>
            </div>
          }
        </div>
      </div>
    }
  `,
  styleUrls: ['../style.css'],
  providers: [],
})
export class RadioButtonCompilingComponent {
  protected widgetService = inject(
    CompilingWidgetService<RadioButtonCustomization>,
  );

  protected topologyStyle = ' flex-row flex-wrap gap-x-5 gap-y-2';
  protected groupId = `'radioButton_${this.widgetService.uniqueId}`;

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }
}
